<div *ngIf="inputMessage || (error && error !== false)">
    <span class="text-error">{{message}}</span>
</div>
